import React from "react";
import assets from "../assets/assets";
import CountUp from "react-countup";

const Trophy = () => {
  const { bg_circle, Cr_vision, trophy,
    demo_it_business_icon,
    demo_it_business_icontWO,
    demo_it_business_icontHREE,
  } = assets();

  return (
    <section className="p-0 border-color-extra-medium-gray">
      <div className="container">
        <div
          className="row row-cols-1  row-cols-lg-3 row-cols-md-2 justify-content-center mb-7"
          data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'
        >
          <div className="col icon-with-text-style-01 md-mb-30px">
            <div className="feature-box feature-box-left-icon last-paragraph-no-margin">
              <div className="feature-box-icon me-20px">
                <img
                  alt=""
                  src={demo_it_business_icon}
                // className="w-100 h-100"
                // style="display:none;visibility:hidden;"
                />
                <noscript>
                  <img src={demo_it_business_icon} alt="" />
                </noscript>
              </div>
              <div className="feature-box-content">
                <span className="d-inline-block fs-18 text-dark-gray fw-700 mb-5px">
                  Grow your business
                </span>
                <p className="w-80 xl-w-90 lg-w-100">
                  We believe in challenges and so we have made challenges.
                </p>
              </div>
            </div>
          </div>

          <div className="col icon-with-text-style-01 md-mb-30px">
            <div className="feature-box feature-box-left-icon last-paragraph-no-margin">
              <div className="feature-box-icon me-20px">
                <img
                  alt=""
                  src={demo_it_business_icontWO}
                // className="d-none visible "
                // style="display:none;visibility:hidden;"
                />
                <noscript>
                  <img src={demo_it_business_icontWO} alt="" />
                </noscript>
              </div>
              <div className="feature-box-content">
                <span className="d-inline-block fs-18 text-dark-gray fw-700 mb-5px">
                  Cost savings ideas
                </span>
                <p className="w-80 xl-w-90 lg-w-100">
                  We also help our clients with social media strategy.
                </p>
              </div>
            </div>
          </div>

          <div className="col icon-with-text-style-01 md-mb-30px">
            <div className="feature-box feature-box-left-icon last-paragraph-no-margin">
              <div className="feature-box-icon me-20px">
                <img
                  alt=""
                  src={demo_it_business_icontHREE}
                // className="d-none visible"
                // style="display:none;visibility:hidden;"
                />
                <noscript>
                  <img src={demo_it_business_icontHREE} alt="" />
                </noscript>
              </div>
              <div className="feature-box-content">
                <span className="d-inline-block fs-18 text-dark-gray fw-700 mb-5px">
                  Boost performance
                </span>
                <p className="w-80 xl-w-90 lg-w-100">
                  We deliver email marketing campaigns to your audience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 pt-5 mb-5">
        <div className="container">
          <div
            className="row justify-content-center align-items-center mb-6 sm-pb-9"
            data-anime='{"el": "childs", "opacity": [0, 1], "duration": 600, "delay": 0, "staggervalue": 15, "easing": "easeOutQuad"}'
          >
            <div
              className="col-lg-6 col-md-9 position-relative md-mb-15 text-center text-lg-start"
              data-anime='{"el": "childs", "opacity": [0, 1], "duration": 600, "delay": 0, "staggervalue": 15, "easing": "easeOutQuad"}'
            >
              <div className="absolute-middle-center z-index-9 counter-style-02 text-center">
                <span className="fs-160 fw-800 text-dark-gray ls-minus-10px xs-ls-minus-5px position-relative lg-fs-130 xs-fs-75">
                <CountUp start={0} end={28} duration={6} separator="," />
                  <sub className="align-top fs-80 lg-fs-70 text-dark-gray position-relative top-minus-3px">
                    +
                  </sub>
                </span>
                <span className="d-block mx-auto fs-20 fw-500 lh-26 w-70 text-center text-dark-gray xs-w-100">
                  Years working experience
                </span>
              </div>
              <img
                alt=""
                src={bg_circle}
              />
              <noscript>
                <img src={bg_circle} alt="" />
              </noscript>
              <img
                className="position-absolute top-50 left-minus-100px lg-left-minus-40px sm-left-minus-30px lg-w-50 sm-w-55"
                data-bottom-top="transform: translateY(50px)"
                data-top-bottom="transform: translateY(-220px)"
                alt=""
                src={Cr_vision}
              />
              <noscript>
                <img
                  src={Cr_vision}
                  className="position-absolute top-50 left-minus-100px lg-left-minus-40px sm-left-minus-30px lg-w-50 sm-w-55"
                  data-bottom-top="transform: translateY(50px)"
                  data-top-bottom="transform: translateY(-220px)"
                  alt=""
                />
              </noscript>
              <img
                className="position-absolute top-0px xl-top-minus-10px w-170px right-20px md-right-40px xs-w-40"
                data-bottom-top="transform: translateY(-50px)"
                data-top-bottom="transform: translateY(50px)"
                alt=""
                src={trophy}
              />
              <noscript>
                <img
                  src={trophy}
                  className="position-absolute top-0px xl-top-minus-10px w-170px right-20px md-right-40px xs-w-40"
                  data-bottom-top="transform: translateY(-50px)"
                  data-top-bottom="transform: translateY(50px)"
                  alt=""
                />
              </noscript>
            </div>
            <div
              className="col-lg-6 ps-6 text-center text-lg-start lg-ps-15px"
              data-anime='{"el": "childs", "translateY": [30, 0], "opacity": [0, 1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad"}'
            >
              <span className="ps-25px pe-25px mb-20px text-uppercase text-base-color fs-14 lh-42px fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-block">
                Creative approach
              </span>
              <h3 className="text-dark-gray fw-700 ls-minus-1px">
                Powerful agency for corporate business.
              </h3>
              <p className="w-80 xl-w-90 lg-w-100 mb-40px sm-mb-25px">
                We strive to develop real-world web solutions that are ideal for
                small to large projects with bespoke project requirements. We
                create compelling web designs, which are the right-fit for your
                target groups and also deliver optimized.
              </p>
              <a
                href="/our-concern"
                className="btn btn-large btn-dark-gray btn-hover-animation-switch btn-box-shadow btn-rounded me-25px xs-me-0"
              >
                <span>
                  <span className="btn-text">Read about us</span>
                  <span className="btn-icon">
                    <i className="feather icon-feather-arrow-right"></i>
                  </span>
                  <span className="btn-icon">
                    <i className="feather icon-feather-arrow-right"></i>
                  </span>
                </span>
              </a>
              <span className="text-dark-gray fw-700 ls-minus-05px d-block d-sm-inline-block sm-mt-15px">
                <a href="tel:1800222000">
                  <i className="feather icon-feather-phone-call me-10px"></i>1
                  800 222 000
                </a>
              </span>
            </div>
          </div>
          <div
            className="row row-cols-1 row-cols-md-4 row-cols-sm-2 justify-content-center counter-style-07 ps-3 pe-3"
            data-anime='{"el": "childs", "translateY": [50, 0], "opacity": [0, 1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad"}'
          >
            {/* start counter item */}
            <div className="col-6 col-md-3 text-center sm-mb-30px">
              <h2
                className="vertical-counter d-inline-flex text-dark-gray fw-800 mb-0 ls-minus-3px position-relative z-index-0"
              ><CountUp start={0} end={4586} duration={5} separator="," />
                <span className="text-highlight position-absolute bottom-9px w-100">
                  <span className="bg-gradient-flamingo-amethyst-green h-10px opacity-2"></span>
                </span>
              </h2>
              <span className="d-block fs-14 fw-700 text-uppercase text-dark-gray">
                Telephonic talk
              </span>
            </div>
            {/* end counter item */}
            {/* start counter item */}
            <div className="col-6 col-md-3 text-center sm-mb-30px">
              <h2
                className="vertical-counter d-inline-flex text-dark-gray fw-800 mb-0 ls-minus-3px position-relative z-index-0"
              ><CountUp start={0} end={583} duration={5} separator="," />
                <span className="text-highlight position-absolute bottom-9px w-100">
                  <span className="bg-gradient-flamingo-amethyst-green h-10px opacity-2"></span>
                </span>
              </h2>
              <span className="d-block fs-14 fw-700 text-uppercase text-dark-gray">
                Cases solved
              </span>
            </div>
            {/* end counter item */}
            {/* start counter item */}
            <div className="col-6 col-md-3 text-center sm-mb-30px">
              <h2
                className="vertical-counter d-inline-flex text-dark-gray fw-800 mb-0 ls-minus-3px position-relative z-index-0"
              ><CountUp start={0} end={6548} duration={5} separator="," />
                <span className="text-highlight position-absolute bottom-9px w-100">
                  <span className="bg-gradient-flamingo-amethyst-green h-10px opacity-2"></span>
                </span>
              </h2>
              <span className="d-block fs-14 fw-700 text-uppercase text-dark-gray">
                Coffee cups
              </span>
            </div>
            {/* end counter item */}
            {/* start counter item */}
            <div className="col-6 col-md-3 text-center">
              <h2
                className="vertical-counter d-inline-flex text-dark-gray fw-800 mb-0 ls-minus-3px position-relative z-index-0"
              ><CountUp start={0} end={836} duration={5} separator="," />
                <span className="text-highlight position-absolute bottom-9px w-100">
                  <span className="bg-gradient-flamingo-amethyst-green h-10px opacity-2"></span>
                </span>
              </h2>
              <span className="d-block fs-14 fw-700 text-uppercase text-dark-gray">
                Happy clients
              </span>
            </div>
            {/* end counter item */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trophy;
